/* eslint-disable no-console */
import { getItemsFromAccount } from '../consumer-account/storage-actions';
import { checkAvailability } from '../dealer-availability/dealer-lookup-form';
import { updateEmalSignupForm } from '../dealer-availability/email-signup-form';
import DealerAvailabilityModal from '../dealer-availability-modal';
import { clearInputValues, removeAllErrors, resetSelectValues, validate } from '../../utils/form-validation-utils';
import { sendProductLeadToDrip } from '../drip-helpers';
import SiteModal from '../site-modal';

const updateSingleProductDealerShareModal = (options) => {
  const {
    photos,
    selectedColorName,
  } = options;
  const modalDiv = document.querySelector('.dealer-share-modal');
  // Set color name
  const colorNameDiv = modalDiv.querySelector('.selected-colorname');
  colorNameDiv.innerHTML = selectedColorName;
  // Set product preview image
  if (photos.primaryImage) {
    const productPreviewImg = modalDiv.querySelector('.selected-color-product-preview');
    productPreviewImg.srcset = photos.primaryImage.url;
    productPreviewImg.setAttribute('data-src', photos.primaryImage.url);
    productPreviewImg.setAttribute('alt', photos.primaryImage.alt);
  }
  // Update hidden input for colorname
  const colorNameIpt = modalDiv.querySelector('#ColorName');
  colorNameIpt.value = selectedColorName;
};

const clearDealerLoookupFormData = () => {
  const form = document.querySelector('.dealer-share-form');
  if (form) {
    removeAllErrors(form);
    clearInputValues(form);
    resetSelectValues(form);
  }
};

const showMyFavoritesSubmitConfirmationState = () => {
  const modalDiv = document.querySelector('.dealer-share-modal');
  if (!modalDiv) {
    return;
  }
  const form = modalDiv.querySelector('.dealer-share-form');
  const formConfirmationDiv = modalDiv.querySelector('.form-submit-confirmation');
  const myFavoritesSubmitConfirmationDiv = modalDiv.querySelector('.my-favorites-submit-confirmation');
  const formConfirmationWithFavoritesDiv = modalDiv.querySelector('.form-submit-confirmation-with-favorites');
  form.classList.add('hidden');
  formConfirmationDiv.classList.add('hidden');
  formConfirmationWithFavoritesDiv.classList.add('hidden');
  myFavoritesSubmitConfirmationDiv.classList.remove('hidden');
};

const addSingleProductDealerShareModal = () => {
  const modalDiv = document.querySelector('.dealer-share-modal');
  if (!modalDiv) {
    return;
  }

  const updateModalHeight = () => {
    let contentHeight = modalDiv.querySelector('.modal-content').offsetHeight + 30;
    // Check for .product-swatches-modal.modal-visible
    const productSwatchesModalDiv = document.querySelector('.product-swatches-modal.modal-visible .modal-panel');
    if (productSwatchesModalDiv) {
      if (contentHeight < productSwatchesModalDiv.offsetHeight) {
        contentHeight = productSwatchesModalDiv.offsetHeight;
      }
    }
    modalDiv.querySelector('.modal-panel').style.height = `${contentHeight}px`;
  };

  // Init modal
  const modal = new SiteModal({
    id: 'dealer-share-modal',
    callbacks: {
      onOpen: () => {
        updateModalHeight();
      },
      onClose: () => {
        clearDealerLoookupFormData();
        resetDefaultState(); /* eslint-disable-line no-use-before-define */
      },
    },
  });
  // Add share w/ dealer event handler
  const shareWithDealerBtn = document.querySelector('.share-with-dealer-btn');
  if (shareWithDealerBtn) {
    shareWithDealerBtn.addEventListener('click', () => {
      modal.open();
    });
  }
  // Add continue shopping events
  const continueShoppingBtn = modalDiv.querySelector('.continue-shopping-btn');
  if (continueShoppingBtn) {
    continueShoppingBtn.addEventListener('click', () => {
      modal.close();
    });
  }
  // Add resize listener
  window.addEventListener('resize', updateModalHeight);
  // Form
  const form = modalDiv.querySelector('.dealer-share-form');
  const zipIpt = form.querySelector('#Zip');
  const formError = form.querySelector('.form-error-message');
  const submitBtn = form.querySelector('.submit-btn');
  const formConfirmationDiv = modalDiv.querySelector('.form-submit-confirmation');
  const formConfirmationWithFavoritesDiv = modalDiv.querySelector('.form-submit-confirmation-with-favorites');
  const myFavoritesSubmitConfirmationDiv = modalDiv.querySelector('.my-favorites-submit-confirmation');

  // Set up measurement select event listeners
  const updateSelectedValues = () => {
    const width1 = form.querySelector('#Width1').value;
    const width2 = form.querySelector('#Width2').value;
    const height1 = form.querySelector('#Height1').value;
    const height2 = form.querySelector('#Height2').value;
    const windowWidthIpt = form.querySelector('#WindowWidth');
    const windowHeightIpt = form.querySelector('#WindowHeight');
    if (width1 !== 'any') {
      windowWidthIpt.value = `${width1}${width2}`;
      window.selectedProductWidth = `${width1}${width2}`;
    }
    if (height1 !== 'any') {
      windowHeightIpt.value = `${height1}${height2}`;
      window.selectedProductHeight = `${height1}${height2}`;
    }
    const notes = form.querySelector('#Message').value;
    window.selectedProductNotes = notes;
  };
  /* const measureSelects = form.querySelectorAll('.product-dimensions-group select');
  [].map.call(measureSelects, select => (
    select.addEventListener('change', () => {
      updateSelectedMeasurements();
    })
  )); */

  const getItemByProductCode = (data, id) => (
    data.find(item => id === item['product-key'])
  );

  const disableSubmitBtn = () => {
    submitBtn.setAttribute('disabled', 'disabled');
    submitBtn.value = 'Sending...';
  };

  const enableSubmitBtn = () => {
    submitBtn.removeAttribute('disabled');
    submitBtn.value = 'Submit';
  };

  const showFormError = () => {
    formError.classList.remove('hidden');
    updateModalHeight();
    formError.focus();
  };

  const hideFormError = () => {
    formError.classList.add('hidden');
    updateModalHeight();
  };

  const resetDefaultState = () => {
    form.classList.remove('hidden');
    formConfirmationDiv.classList.add('hidden');
    myFavoritesSubmitConfirmationDiv.classList.add('hidden');
  };

  const showConfirmationState = () => {
    form.classList.add('hidden');
    formConfirmationDiv.classList.remove('hidden');
    formConfirmationWithFavoritesDiv.classList.add('hidden');
    myFavoritesSubmitConfirmationDiv.classList.add('hidden');
    updateModalHeight();
  };

  const showConfirmationFavoritesState = () => {
    form.classList.add('hidden');
    formConfirmationDiv.classList.add('hidden');
    formConfirmationWithFavoritesDiv.classList.remove('hidden');
    myFavoritesSubmitConfirmationDiv.classList.add('hidden');
    updateModalHeight();
  };

  const showConfirmation = () => {
    const { isAuthenticated, selectedColorVariant } = window;
    const { code } = selectedColorVariant;
    // Determine which confirmation state to show
    // depending on authentication and whether
    // product shared has already been saved to favorites
    if (!isAuthenticated) {
      showConfirmationFavoritesState();
      return;
    }
    getItemsFromAccount('product', (data) => {
      const product = getItemByProductCode(data.products, code);
      if (product) {
        showConfirmationState();
      } else {
        showConfirmationFavoritesState();
      }
    });
  };

  const submitForm = () => {
    removeAllErrors(form);
    hideFormError();
    const { dealerAvailabilityCheckRadius } = window;
    if (validate(form)) {
      disableSubmitBtn();
      checkAvailability({
        address: zipIpt.value,
        radius: dealerAvailabilityCheckRadius,
        onDealerAvailable: () => {
          updateSelectedValues();
          sendProductLeadToDrip(form);
          enableSubmitBtn();
          showConfirmation();
          updateModalHeight();
        },
        onDealerNotAvailable: () => {
          // Pass email address to email signup form
          const email = form.querySelector('#Email').value;
          updateEmalSignupForm({ email });
          DealerAvailabilityModal({
            state: 'dealer-not-available',
          });
          updateModalHeight();
          enableSubmitBtn();
        },
        onError: () => {
          enableSubmitBtn();
          showFormError();
        },
      });
    } else {
      updateModalHeight();
    }
  };

  submitBtn.addEventListener('click', (event) => {
    event.preventDefault();
    submitForm();
  });
};

export {
  addSingleProductDealerShareModal,
  showMyFavoritesSubmitConfirmationState,
  updateSingleProductDealerShareModal,
};
/* eslint-enable no-console */
